export default theme => ({
    root: {
        //Cambia estilo base, por custom
        backgroundColor: '#0b1738',
        //backgroundColor: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
        

     
    },
    logoWrapperCollapsed: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '63px',
        flexShrink: 0,
        paddingTop: "63%"
    },
    logoWrapperNoCollapsed: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '63px',
        flexShrink: 0,
        paddingTop: "15%"
    },
    logoLink: {
        fontSize: 0
    },
    logoImage: {
        cursor: 'pointer',
        height: 45,
    },
    logoDivider: {
        marginBottom: theme.spacing(1)
    },
    profile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatar: {
        width: '100px',
        height: '80px'
    },
    nameText: {
        marginTop: theme.spacing(1)
    },
    bioText: {},


    profileDivider: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        //Cambia estilo base, por custom
        backgroundColor: '#0b1738',
        
    },
    listSubheader: {
        //color: theme.palette.text.secondary,
        color: '#b2b2b2',
    },
    listItem: {
        
        //Cambia estilo base, por custom
        backgroundColor: '#0b1738',
        cursor: 'pointer',
        '&:hover': {
            //backgroundColor: theme.palette.primary.light,
            borderLeft: `4px solid #f57000 `,
            //borderLeft: `4px solid ${theme.palette.primary.main}`,
            borderRadius: '4px',
            '& $listItemIcon': {
                color: '#f57000',
                //color: theme.palette.primary.main,
                marginLeft: '-4px'
            }
        },
        '& + &': {
            marginTop: theme.spacing(3)
        },
        '&:focus': {
            outline: 'none',
        }
    },
    listItemCollapsed: {
        
        //Cambia estilo base, por custom
        backgroundColor: '#0b1738',
        cursor: 'pointer',
        height: '50px',
        '&:hover': {
            //backgroundColor: theme.palette.primary.light,
            borderLeft: `4px solid #f57000 `,
            //borderLeft: `4px solid ${theme.palette.primary.main}`,
            borderRadius: '4px',
            '& $listItemIcon': {
                color: '#f57000',
                //color: theme.palette.primary.main,
                marginLeft: '-4px'
            }
        },
        '& + &': {
            marginTop: theme.spacing(1)
        }
    },
    activeListItem: {
        //Cambia estilo base, por custom
        borderLeft: `4px solid #f57000`,
        //borderLeft: `4px solid ${theme.palette.primary.main}`,
        borderRadius: '4px',
        //backgroundColor: theme.palette.primary.light,
        //Cambia estilo base, por custom
        backgroundColor: '#434c54',
       
        '& $listItemText': {
            //color: theme.palette.text.primary
            //Cambia estilo base, por custom
            color: '#ffffff',
        },
        '& $listItemIcon': {
            //color: theme.palette.primary.main,
            color: '#f57000',
            marginLeft: '-4px'
        },
        '&:focus': {
            outline: 'none',
        }
    },
    activeListItemCollapsed: {
        //Cambia estilo base, por custom
        borderLeft: `4px solid #f57000`,
        height: '50px',
        //borderLeft: `4px solid ${theme.palette.primary.main}`,
        borderRadius: '4px',
        //backgroundColor: theme.palette.primary.light,
        //Cambia estilo base, por custom
        backgroundColor: '#434c54',
       
        '& $listItemText': {
            //color: theme.palette.text.primary
            //Cambia estilo base, por custom
            color: '#ffffff',
        },
        '& $listItemIcon': {
            //color: theme.palette.primary.main,
            color: '#f57000',
            marginLeft: '-4px'
        }
    },
    listItemIcon: {
        marginRight: 0,
        //Cambia estilo base, por custom
        
        color:'#b2b2b2'
        
    },
    listItemIconFilter: {
        justifyContent: 'right',
    },
    listItemText: {
        fontWeight: 500,
        //color: theme.palette.text.secondary
        color:'#bfbfbf'
    },
    listDivider: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        //Cambia estilo base, por custom
        backgroundColor: '#434c54',
    },
    ballotIcon: {
        color: '#b2b2b2',
        cursor: 'pointer',
        '&:hover': {
            //backgroundColor: theme.palette.primary.light,
            //borderLeft: `2px solid ${theme.palette.primary.main}`,
            color: '#f57000',
            borderRadius: '4px',
            //color: theme.palette.primary.main,
            //marginLeft: '-4px'
        },
        marginTop: 4,
        marginLeft: 4
    },
    ballotIconChecked: {
        color: theme.palette.primary.main,
        marginTop: 4,
        marginLeft: 4
    },
    //Agrega Custom ScrollBar
    customScrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-track-piece': {
            background: '#525252'
        },
        '&::-webkit-scrollbar-thumb:horizontal': {
            background: '#E5E5E5',
            },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(245,112,0,.8)',
            outline: '1px solid slategrey'
        }
        
    },
    modal: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '75vw',
        [theme.breakpoints.up('xs')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
    drawerPaper: {
        zIndex: 1200,
        width: '271px',
      },
});